{
  "version": "3.68.19",
  "api": {
    "region": "us-east-1",
    "key": "wIkpRlPdhJCfEsK9F8WhIB5rg5BJ1LOSaYeCDvtx",
    "url": "api.waterfordlabs.org",
    "protocol": "https"
  },
  "dashboards": {
    "url": "https://dashboard-plugin.waterford.org/wel_manager"
  },
  "content": {
    "url": "https://content.waterford.org",
    "cloudFrontUrl": "https://d1hsa6e2n2ycln.cloudfront.net",
    "videoTemplateId": "262"
  },
  "contentV3": {
    "url": "https://content-v3.waterford.org"
  },
  "resources": {
    "url": "https://resources.waterford.org"
  },
  "fusion": {
    "loginUrl": "https://signin.waterford.org",
    "adminLoginUrl": "https://adminsignin.waterford.org",
    "userLookupUrl": "https://api.waterford.org/user-lookup/v2"
  },
  "helpMessages": {
    "wacs": {
      "en": {
        "url": "https://resources.waterford.org/content/2177/2177.html"
      },
      "es": {
        "url": "https://resources.waterford.org/content/2178/2178.html"
      }
    }
  },
  "sentry": {
    "dsn": "https://36a869d12df41278c64a86bd12793873@o1133904.ingest.us.sentry.io/4509121749581824",
    "environment": "prod",
    "tracesSampleRate": 0
  },
  "notifications": {
    "websocketUrl": "wss://ws-api.waterfordlabs.org/notification-websockets"
  },
  "snowplow": {
    "collectorUrl": "https://snowplow.waterford.org"
  },
  "eula": {
    "en": "https://resources.waterford.org/data-source/4579/4579.html",
    "es": "https://resources.waterford.org/data-source/4580/4580.html"
  },
  "aha": {
    "account": "waterfordlabs",
    "applicationId": "6394799042705956786"
  },
  "amazonConnect": {
    "id": "c69c3da2-51dd-44fb-a7b7-d84bd31c28a7",
    "snippetId": "QVFJREFIaXdlaTllQXR1SnQyK1JZc1Z3dWE3clBZQjQvWm15emlVb25scEltc3BJNmdFMWNzV1dMWHVsdFFJNjBZUVZ2YWZpQUFBQWJqQnNCZ2txaGtpRzl3MEJCd2FnWHpCZEFnRUFNRmdHQ1NxR1NJYjNEUUVIQVRBZUJnbGdoa2dCWlFNRUFTNHdFUVFNcE1lek8vNnNPbzJyaGxVM0FnRVFnQ3VIbDBKdlZmWkFDQkJvN2QwaHZQeFZSWW9NRDNoelhBU2lTZFZCbkZ3YlRlMW5ZNXlnYTZEMDF0Y3U6OkIrMi9WdnlaaXlYaWJjNTNEdFJNNVdwZzlKQXA1RTdZZ3AyWXdjdzlaVnc5Z0Qwd2JuUFBqdjZzUkRTUjRDcGxPRDhQdGJQUDJwNm9Vdis1Q3VhbVU3V2h3MU9HYm1MUnZkL2VYQ013cHN4a2xvUUtoVjJ6RTNvdnBJM2RhbkVHSnQ1V0trWjk2b1plQUxzOGM0cnlIUFlGWEEySlQ2UT0="
  }
}